var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.show,
          expression: "show"
        }
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.show)
          ? _vm._i(_vm.show, null) > -1
          : _vm.show
      },
      on: {
        change: function($event) {
          var $$a = _vm.show,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.show = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.show = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.show = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.src,
            expression: "src"
          }
        ],
        staticStyle: { width: "30em" },
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.src = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }
        }
      },
      [_c("option")]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.page,
          expression: "page",
          modifiers: { number: true }
        }
      ],
      staticStyle: { width: "5em" },
      attrs: { type: "number" },
      domProps: { value: _vm.page },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.page = _vm._n($event.target.value)
        },
        blur: function($event) {
          return _vm.$forceUpdate()
        }
      }
    }),
    _vm._v(" /" + _vm._s(_vm.numPages) + "\n  "),
    _c(
      "button",
      {
        on: {
          click: function($event) {
            _vm.rotate += 90
          }
        }
      },
      [_vm._v("⟳")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        on: {
          click: function($event) {
            _vm.rotate -= 90
          }
        }
      },
      [_vm._v("⟲")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        on: {
          click: function($event) {
            return _vm.$refs.pdf.print()
          }
        }
      },
      [_vm._v("print")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { width: "50%" } },
      [
        _vm.loadedRatio > 0 && _vm.loadedRatio < 1
          ? _c(
              "div",
              {
                staticStyle: {
                  "background-color": "green",
                  color: "white",
                  "text-align": "center"
                },
                style: { width: _vm.loadedRatio * 100 + "%" }
              },
              [_vm._v(_vm._s(Math.floor(_vm.loadedRatio * 100)) + "%")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.show
          ? _c("pdf", {
              ref: "pdf",
              staticStyle: { border: "1px solid red" },
              attrs: { src: _vm.src, page: _vm.page, rotate: _vm.rotate },
              on: {
                password: _vm.password,
                progress: function($event) {
                  _vm.loadedRatio = $event
                },
                error: _vm.error,
                "num-pages": function($event) {
                  _vm.numPages = $event
                },
                "link-clicked": function($event) {
                  _vm.page = $event
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a3ae912", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a3ae912","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/pdf/PDFPrueba.vue
// module id = 660
// module chunks = 0